import Hero from './components/Hero';
import Navbar from './components/Navbar';
import React from 'react';
import Button from './components/Button'


const App = () => {
  return (


    <>


    
     <div>
      <Navbar />
      <Hero />
      <Button />
    </div>
    
    
    </>

   
  )
}

export default App









